
(function () {
  var D = window.__tt; if (!D) return;
  var root = document.querySelector('.tt'); if (!root) return;
  var q = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var one = function (s) { return root.querySelector(s); };
  var S = { pk: D.defaultPk, img: 0, opt: D.defaultOpt, rf: 0 };

  function pickVal(v, i) {
    return Object.prototype.toString.call(v) === '[object Array]' ? v[i] : v;
  }

  function renderPack() {
    q('[data-pk]').forEach(function (b, i) {
      var on = i === S.pk;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    q('[data-picks]').forEach(function (p) {
      p.hidden = +p.getAttribute('data-picks') !== S.pk;
    });
    var t = D.tiers[S.pk] || {};
    var lab = one('[data-cta-label]'); if (lab) lab.textContent = t.cta || '';
    var st = one('[data-sticky-label]'); if (st) st.textContent = t.sticky || '';
    // gifts
    (D.gifts || []).forEach(function (g, i) {
      var open = S.pk >= g.unlock;
      var tile = one('[data-gf="' + i + '"]');
      var lock = one('[data-gf-lock="' + i + '"]');
      var val = one('[data-gf-val="' + i + '"]');
      var lb = one('[data-gf-lab="' + i + '"]');
      if (lock) lock.hidden = open;
      if (tile) tile.classList.toggle('is-locked', !open);
      if (val) val.textContent = 'FREE ' + pickVal(g.value, S.pk);
      if (lb) lb.textContent = pickVal(g.label, S.pk);
    });
    var bar = one('[data-bar]');
    if (bar && D.bar) bar.style.width = D.bar[S.pk];
  }

  // a designed card must not be cropped, and the badge/sticker must not sit on it
  function isCard(src) {
    return /-0(3|6|8)\./.test(src || '');
  }
  function markStage(src) {
    var st = one('.gal__stage');
    if (st) st.classList.toggle('is-card', isCard(src));
  }
  function renderImg() {
    var big = one('[data-big]');
    if (big && D.gallery[S.img]) { big.src = D.gallery[S.img]; markStage(D.gallery[S.img]); }
    q('[data-thumb]').forEach(function (t, i) { t.classList.toggle('is-on', i === S.img); });
  }

  function setOpt(i) {
    S.opt = i;
    if (D.optImages && D.optImages[i]) {
      var big = one('[data-big]');
      if (big) { big.src = D.optImages[i]; markStage(D.optImages[i]); }
    }
    q('[data-th]').forEach(function (im) {
      if (D.optThumbs && D.optThumbs[i]) im.src = D.optThumbs[i];
    });
    q('[data-opt1]').forEach(function (s) { s.value = String(i); });
  }

  q('[data-pk]').forEach(function (b, i) {
    b.addEventListener('click', function () { S.pk = i; renderPack(); });
  });
  q('[data-thumb]').forEach(function (b, i) {
    b.addEventListener('click', function () { S.img = i; renderImg(); });
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-opt1]')) setOpt(+e.target.value);
  });
  q('[data-rf]').forEach(function (b, i) {
    b.addEventListener('click', function () {
      S.rf = i;
      q('[data-rf]').forEach(function (x, j) {
        x.classList.toggle('is-on', j === i);
        x.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
    });
  });

  renderPack(); renderImg();
  if (D.optImages) setOpt(S.opt);
})();
